import { Payroll } from "src/redux/types/payroll";
import PayrollDetailsDialogue from "./PayrollDetailsDialogue";
import EditPayrollDialogue from "./EditPayrollDialogue";

interface PayrollTableProps {
  payroll: Payroll [];
}

const PayrollTable = ({ payroll }: PayrollTableProps) => {
  return (
    <div className="bg-card shadow-sm rounded-xl p-6">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="text-gray-500">
            <th className="pb-2">Emp Code</th>
            <th className="pb-2">Name</th>
            <th className="pb-2">Designation</th>
            <th className="pb-2">Month/Year</th>
          </tr>
        </thead>
        <tbody>
          {payroll.length > 0 &&
            payroll.map((p, i) => (
              <tr key={i} className="border-t border-gray-200">
                <td className="py-2">{p.employee_code}</td>
                <td className="py-2 capitalize">{p.name}</td>
                <td className="py-2">{p.designation}</td>
                <td className="py-2">{`${p.month}/${p.year}`}</td>
                <td className="py-2 flex justify-end">
                  <PayrollDetailsDialogue payroll={p}>
                    <span className="px-4 py-2 rounded-lg">View</span>
                  </PayrollDetailsDialogue>

                  <EditPayrollDialogue payroll={p}>
                    <span className="px-4 py-2 rounded-lg">Edit</span>
                  </EditPayrollDialogue>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default PayrollTable